export default __webpack_public_path__ + "static/media/photo--lg--59.626503e7.jpg";